import { css } from '@emotion/core';
import { mq } from '../../cssInJs';

// sits just left of the hamburger - keep size/top in sync with hamburgerStyle.js
const size = [44, null, 56];

export default {
  button: css(mq({
    position: 'fixed',
    zIndex: '1000',
    top: [8, null, 47],
    right: [44, null, 76],
    width: size,
    height: size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    transition: 'all 0.3s ease-in-out',
    'svg': {
      width: ['26px', null, '34px'],
      height: ['26px', null, '34px'],
    },
    '&:hover, &:focus': {
      color: '#fff',
      opacity: 0.85,
    },
  })),
  buttonScrolled: css(mq({
    top: [0, null, 0],
    color: '#2e3192',
    '&:hover, &:focus': {
      color: '#2e3192',
    },
  })),
  count: css(mq({
    position: 'absolute',
    top: [4, null, 6],
    right: [2, null, 4],
    minWidth: 18,
    height: 18,
    padding: '0 5px',
    borderRadius: 9,
    backgroundColor: '#c1272d',
    color: '#fff',
    fontSize: '11px',
    fontWeight: 'bold',
    lineHeight: '18px',
    textAlign: 'center',
  })),
};
